import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && _indexOfInstanceProperty(e).call(e, p) < 0) t[p] = s[p];

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (_indexOfInstanceProperty(e).call(e, p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable no-unused-vars */

/* eslint-disable max-len */


import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { cssClasses, strings } from '@douyinfe/semi-foundation/lib/es/tag/constants';
import Avatar from '../avatar/index';
import { IconClose } from '@douyinfe/semi-icons';
import '@douyinfe/semi-foundation/lib/es/tag/tag.scss';
export * from './interface';
const prefixCls = cssClasses.PREFIX;
const tagColors = strings.TAG_COLOR;
const tagSize = strings.TAG_SIZE;
const tagType = strings.TAG_TYPE;
const avatarShapeSet = strings.AVATAR_SHAPE;
export default class Tag extends Component {
  constructor(props) {
    var _context;

    super(props);
    this.state = {
      visible: true
    };
    this.close = _bindInstanceProperty(_context = this.close).call(_context, this);
  } // any other way to achieve this?


  static getDerivedStateFromProps(nextProps) {
    if ('visible' in nextProps) {
      return {
        visible: nextProps.visible
      };
    }

    return null;
  }

  setVisible(visible) {
    if (!('visible' in this.props)) {
      this.setState({
        visible
      });
    }
  }

  close(e, value) {
    const {
      onClose
    } = this.props;
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onClose && onClose(value, e); // when user call e.preventDefault() in onClick callback, tag will not hidden

    if (e.defaultPrevented) {
      return;
    }

    this.setVisible(false);
  }

  renderAvatar() {
    const {
      avatarShape,
      avatarSrc
    } = this.props;
    const avatar = /*#__PURE__*/React.createElement(Avatar, {
      src: avatarSrc,
      shape: avatarShape
    });
    return avatar;
  }

  render() {
    var _context2, _context3, _context4, _context5;

    const _a = this.props,
          {
      children,
      size,
      color,
      closable,
      visible,
      onClose,
      className,
      type,
      avatarSrc,
      avatarShape
    } = _a,
          attr = __rest(_a, ["children", "size", "color", "closable", "visible", "onClose", "className", "type", "avatarSrc", "avatarShape"]);

    const {
      visible: isVisible
    } = this.state;

    const baseProps = _Object$assign(_Object$assign({}, attr), {
      className: classNames(prefixCls, {
        ["".concat(prefixCls, "-default")]: size === 'default',
        ["".concat(prefixCls, "-small")]: size === 'small',
        ["".concat(prefixCls, "-large")]: size === 'large',
        [_concatInstanceProperty(_context2 = "".concat(prefixCls, "-")).call(_context2, type)]: type,
        [_concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "".concat(prefixCls, "-")).call(_context4, color, "-")).call(_context3, type)]: color && type,
        ["".concat(prefixCls, "-closable")]: closable,
        ["".concat(prefixCls, "-invisible")]: !isVisible,
        [_concatInstanceProperty(_context5 = "".concat(prefixCls, "-avatar-")).call(_context5, avatarShape)]: avatarSrc
      }, className)
    });

    const closeIcon = closable ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-close"),
      onClick: e => this.close(e, children)
    }, /*#__PURE__*/React.createElement(IconClose, {
      size: "small"
    })) : null;
    return /*#__PURE__*/React.createElement("div", _Object$assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, avatarSrc ? this.renderAvatar() : null, children, closeIcon));
  }

}
Tag.defaultProps = {
  size: tagSize[0],
  color: tagColors[0],
  closable: false,
  // visible: true,
  type: tagType[0],
  onClose: () => undefined,
  onClick: () => undefined,
  style: {},
  className: '',
  avatarShape: 'square'
};
Tag.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(tagSize),
  color: PropTypes.oneOf(tagColors),
  type: PropTypes.oneOf(tagType),
  closable: PropTypes.bool,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string,
  avatarSrc: PropTypes.string,
  avatarShape: PropTypes.oneOf(avatarShapeSet)
};